import { Discount } from 'shared-types/Common';
import React, { FC } from 'react';
import { defaultColors } from '../../../theme/colours';
import { Body3 } from '../../Typography';
import { DiscountBannerWrapper } from './DiscountBanner.styles';

type DiscountBannerProps = {
  discount?: Discount | null;
  margin?: string;
  isPlaced?: boolean;
};

export const DiscountBanner: FC<DiscountBannerProps> = ({ discount, margin, isPlaced = true }) =>
  discount?.name ? (
    <DiscountBannerWrapper margin={margin} isPlaced={isPlaced} data-cy="discount-banner_wrapper">
      <Body3 data-cy="discount_banner_text" color={defaultColors.white}>
        {discount?.name}
      </Body3>
    </DiscountBannerWrapper>
  ) : null;
